/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// Import necessary React and React Router components
import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";

// Import layout components
import Navbar from "../src/components/landingPage/header/Navbar";

import LandingPageHF from "./layouts/LandingPageHF";
import LandingPagesHTF from "./layouts/LandingPagesHTF";
import ErrorPageLayout from "./layouts/ErrorPageLayout";

// Import landing page components
import {
  HomePage,
  AboutPage,
  ContactUs,
  TermsofServicePage,
  PricingPage,
  PrivacyPolicyPage,
  PricingHomePage,
} from "./pages/landingPages/Index";

// Import dashboard components
import {
  MainPage,
  IndexMainPage,
  Appearance,
  Analytics,
  // UpgradeAnalytics,
  // ProAnalytics,
} from "./pages/dashboardPages/index";

// Import large screen main page components
import {
  LinksPage,
  Socials,
  Avatar,
  QrCode,
  Header,
  HeaderText,
  FAQ,
  Youtube,
  Image,
  ImageGrid,
  Divider,
  Countdown,
} from "./pages/dashboardPages/largeScreen/mainPage/addBlocks/index";

// Import error pages
import { PageNotFound, ServerErrorPage } from "./pages/error/Index";

// Import authentication pages
import {
  Login,
  SignUp,
  PasswordPage,
  ForgotPassword,
} from "./pages/auth/Index";

import toast, { Toaster } from "react-hot-toast";
import SideBarLayout from "./layouts/dashboard/SideBarLayout";
import SideBarWithMobile from "./layouts/dashboard/SideBarWithMobile";
import PreviewWithBottomBar from "./pages/dashboardPages/mobile/PreviewWithBottomBar";
import VerifyEmailPage from "./pages/auth/VerifyEmailPage";
import NewPassword from "./pages/auth/NewPassword";
import PreviewPage from "./pages/previewPage/PreviewPage";

// Import mobile appearance pages
import {
  Lists,
  Background,
  Favicon,
  Font,
  Branding,
  Seo,
  AvatarAppearance,
  LinksAppearance,
} from "./pages/dashboardPages/mobile/appearance";

// Import payment pages
import {
  PaymentDetailsFormPage,
  PaymentSuccess,
} from "./pages/landingPages/payment";

// Import setting pages
import {
  Account,
  Billings,
  Page,
  Security,
} from "./pages/dashboardPages/largeScreen/setting";
import SettingPageLayout from "./layouts/dashboard/SettingPageLayout";

import { HomeSettingIndex } from "./pages/dashboardPages/mobile";

// Import guard components
import { RequireAuth } from "./guards/RequireAuth";
import {
  EditAvatar,
  EditCountdown,
  EditDivider,
  EditFAQ,
  EditHeader,
  EditHeaderText,
  EditImage,
  EditImageGrid,
  EditLink,
  EditMediaLink,
  EditQrCode,
} from "./pages/dashboardPages/largeScreen/mainPage/edit";
import useSettings from "./hooks/useSettings";
import { useDispatch, useSelector } from "react-redux";
import { getBlockByPlanId } from "./redux/slices/paymentStripes/paymentStripesSlice";
import { PaidBlocks } from "./guards/PaidBlocks";

import { resetUser, viewUser } from "./redux/slices/user/userSlice";

import { motion } from "framer-motion";
import { initGA, logPageView } from "./pages/landingPages/Analytics";
import ReportAbusePage from "./pages/landingPages/ReportAbusePage";

import InvitionSystem from "./pages/dashboardPages/largeScreen/invitionSystem/InvitionSystem";
import InvitionSystemEdit from "./pages/dashboardPages/largeScreen/invitionSystem/InvitionSystemEdit";
import VerifyEmail from "./pages/landingPages/VerifyEmail";
import InvitionSystemReject from "./pages/dashboardPages/largeScreen/invitionSystem/InvitionSystemReject";
import WaitingListUSer from "./pages/landingPages/WaitingListUser";
import LocationForm from "./pages/dashboardPages/largeScreen/mainPage/forms/locationForms/LocationForm";
import LocationList from "./pages/dashboardPages/largeScreen/mainPage/addBlocks/Locations/LocationList";
import AddLocation from "./pages/dashboardPages/largeScreen/mainPage/addBlocks/Locations/AddLocation";
import EditLocationForm from "./pages/dashboardPages/largeScreen/mainPage/forms/locationForms/EditLocationForm";

import httpRequest from '././axios/index'
import ProtectedRoute from "./pages/auth/ProtectedRoute";
import ConsentCookies from "./pages/landingPages/ConsentCookies";
import { CookiesProvider } from "react-cookie";
import ProtectedButton from "./guards/ProtectedButton";
import { setIsInvitationActive } from "./redux/slices/InvitationSystem/InvitationSlice";

// Helper component for fading in content when visible
export function FadeInWhenVisible({ children, variants, duration }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false }}
      transition={{ duration }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
}

// Helper component for scrolling to the top of the page
const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    initGA();
    logPageView();
    window.scrollTo(0, 0);
  }, [pathname]);
};

const NavbarWrapper = () => {
  const { pathname } = useLocation();

  const Linkdata = useSelector(
    (state) => state?.linkPreview?.userLinkState?.result?.link
  );

  const isPreviewPage = pathname === `/${Linkdata}`;
  const isLoginPage = pathname.includes("/auth/");
  return !(isLoginPage || isPreviewPage) ? <Navbar /> : null;
};

const AnalyticsLocation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await httpRequest.get("api/user/getinvitationmode");
      const isActive = response?.data?.data?.isActive;
      dispatch(setIsInvitationActive(isActive));
    } catch (error) {
      navigate("/auth/login");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

};

function App() {
  // Redux dispatch
  const dispatch = useDispatch();

  // Get theme direction from settings
  const { themeDirection } = useSettings();
  document.dir = themeDirection;

  // Determine if the screen is in mobile view
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 768);

  // Track window width
  const [width, setWidth] = useState(window.innerWidth);

  // const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('user') !== null);

  useEffect(() => {
    if (width > 768) {
      setIsMobileScreen(false);
    }

    // Function to handle window resize
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        setIsMobileScreen(false);
      } else {
        setIsMobileScreen(true);
      }
    };

    // Add a resize event listener and remove it when the component unmounts
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
  }, []);

  // Fetch block features
  useEffect(() => {
    dispatch(getBlockByPlanId());
  }, []);

  // Get user data from local storage or null if not available
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  // Fetch user data when the component mounts
  useEffect(() => {
    if (user) {
      dispatch(viewUser(user?.userid)).then(() => {
        dispatch(resetUser());
        // setIsLoggedIn(true)
      });
    }
  }, []);

  // Fetch user data when the user data changes
  // useEffect(() => {
  //   if (user) {
  //     dispatch(viewUser(user?.userid)).then(() => {
  //       dispatch(resetUser())
  //     // etIsLoggedIn(true)  s
  //     })
  //   }
  // }, [user])

  // Get block features from Redux state
  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );

  return (
    <div className="dark:bg-dark-primary">
      <CookiesProvider>
        <BrowserRouter basename={"/bill"}>
          <NavbarWrapper />
          <ScrollToTop />
          <AnalyticsLocation/>
          <ConsentCookies />
          <Routes>
            <Route path="/" element={<LandingPageHF />}>
              <Route
                index
                element={
                    <HomePage />
                }
              />
              <Route element={<LandingPagesHTF />}>
                <Route
                  path={"about"}
                  element={
                    <ProtectedButton>
                      <AboutPage />
                    </ProtectedButton>
                  }
                />
                <Route
                  path={"verify-email/:email/:code"}
                  element={<VerifyEmail />}
                />
                <Route
                  path={"contact"}
                  element={
                    <ProtectedButton>
                      <ContactUs />
                    </ProtectedButton>
                  }
                />
                <Route path={"WaitingListUSer"} element={<WaitingListUSer />} />
                <Route
                  path={"report-abuse"}
                  element={
                    <ProtectedButton>
                      <ReportAbusePage />
                    </ProtectedButton>
                  }
                />
                <Route
                  path={"pricing"}
                  element={
                    <ProtectedButton>
                      <PricingPage />
                    </ProtectedButton>
                  }
                >
                  <Route index element={<PricingHomePage />} />
                  <Route path={"payment"}>
                    <Route
                      path={"paymentDetailsFormPage/:planType/:planId"}
                      element={
                        <RequireAuth>
                          <PaymentDetailsFormPage />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path={"paymentSuccess"}
                      element={
                        <RequireAuth>
                          <PaymentSuccess />
                        </RequireAuth>
                      }
                    />
                  </Route>
                </Route>
                <Route
                  path={"terms-of-service"}
                  element={<TermsofServicePage />}
                />
                <Route
                  path={"privacy-policy"}
                  element={<PrivacyPolicyPage />}
                />
              </Route>
            </Route>
            <Route path={"auth"}>
              <Route
                path={"verifyemail/:id/:token"}
                element={<VerifyEmailPage />}
              />
              <Route
                path={"new-password/:id/:token"}
                element={<NewPassword />}
              />
              <Route path={"login/:pageNameParam?"} element={<Login />} />
              <Route
                path={"signUp/:email?/:code?"}
                element={
                  <ProtectedRoute>
                    <SignUp />
                  </ProtectedRoute>
                }
              />
              <Route path={"passwordPage"} element={<PasswordPage />} />
              <Route path={"forgotPassword"} element={<ForgotPassword />} />
            </Route>

            <Route element={<ErrorPageLayout />}>
              <Route path={"404"} element={<PageNotFound />} />
              <Route path={"*"} element={<Navigate replace to="404" />} />
              <Route path={"500"} element={<ServerErrorPage />} />
            </Route>

            <Route
              path={"dashboard"}
              element={
                <RequireAuth>
                  <SideBarLayout />
                </RequireAuth>
              }
            >
              <Route element={<SideBarWithMobile />}>
                <Route
                  index
                  element={
                    isMobileScreen ? (
                      <Navigate to="../mDashboard" />
                    ) : (
                      <Navigate to="./component" />
                    )
                  }
                />
                <Route path={"component"} element={<MainPage />}>
                  <Route index element={<IndexMainPage />} />

                  <Route path={"links"} element={<LinksPage />} />
                  <Route path={"editLink/:optionId"} element={<EditLink />} />
                  <Route path={"Social"} element={<Socials />} />
                  <Route path={"editSocial/:optionId"} element={<Socials />} />
                  <Route path={"avatar"} element={<Avatar />} />
                  <Route
                    path={"editAvatar/:optionId"}
                    element={<EditAvatar />}
                  />
                  <Route
                    path={"qrCode"}
                    element={
                      <PaidBlocks>
                        <QrCode />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editQrCode/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditQrCode />
                      </PaidBlocks>
                    }
                  />
                  <Route path={"HeaderText"} element={<HeaderText />} />
                  <Route path={"location"} element={<AddLocation />} />
                  <Route path={"locationForm"} element={<LocationForm />} />
                  <Route path={"locationList"} element={<LocationList />} />
                  <Route
                    path={"editLocationForm/:id"}
                    element={<EditLocationForm />}
                  />

                  <Route path={"textEditor"} element={<Header />} />
                  <Route
                    path={"editTextEditor/:optionId"}
                    element={<EditHeader />}
                  />
                  <Route
                    path={"editHeaderText/:optionId"}
                    element={<EditHeaderText />}
                  />

                  <Route
                    path={"faq"}
                    element={
                      <PaidBlocks>
                        <FAQ />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editFAQ/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditFAQ />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"media/:media"}
                    element={
                      <PaidBlocks>
                        <Youtube />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editMediaLink/:media/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditMediaLink />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editImage/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditImage />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editImageGrid/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditImageGrid />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editDivider/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditDivider />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"editCountdown/:optionId"}
                    element={
                      <PaidBlocks>
                        <EditCountdown />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"image"}
                    element={
                      <PaidBlocks>
                        <Image />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"imageGrid"}
                    element={
                      <PaidBlocks>
                        <ImageGrid />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"divider"}
                    element={
                      <PaidBlocks>
                        <Divider />
                      </PaidBlocks>
                    }
                  />
                  <Route
                    path={"countdown"}
                    element={
                      <PaidBlocks>
                        <Countdown />
                      </PaidBlocks>
                    }
                  />
                </Route>
                <Route path={"appearance"} element={<Appearance />}>
                  <Route index element={<Lists />} />
                  <Route path={"background"} element={<Background />} />
                  <Route path={"favicon"} element={<Favicon />} />
                  <Route path={"font"} element={<Font />} />
                  <Route path={"branding"} element={<Branding />} />
                  <Route path={"seo"} element={<Seo />} />
                  <Route
                    path={"avatarAppearance"}
                    element={<AvatarAppearance />}
                  />
                  <Route
                    path={"linksAppearance"}
                    element={<LinksAppearance />}
                  />
                </Route>
              </Route>
              <Route path={"analytics"} element={<Analytics />} />
              {/* <Route path={"analytics"} element={<UpgradeAnalytics />} /> */}
              {/* <Route path={"pro-analytics"} element={<ProAnalytics />} /> */}

              <Route path={"setting"} element={<SettingPageLayout />}>
                <Route
                  index
                  element={
                    isMobileScreen ? (
                      <Navigate to="./index" />
                    ) : (
                      <Navigate to="./page" />
                    )
                  }
                />
                <Route path={"index"} element={<HomeSettingIndex />} />
                <Route path={"page"} element={<Page />} />
                <Route path={"account"} element={<Account />} />
                <Route path={"security"} element={<Security />} />
                <Route path={"billings"} element={<Billings />} />
                {/* <Route path={'language'} element={<Language />} /> */}
              </Route>
              <Route path={"invitionSystem"} element={<InvitionSystem />} />
              <Route
                path={"invitionSystemEdit"}
                element={<InvitionSystemEdit />}
              />
              <Route
                path={"invitionSystemReject"}
                element={<InvitionSystemReject />}
              />
            </Route>
            <Route
              path={"mDashboard"}
              element={
                <RequireAuth>
                  <PreviewWithBottomBar />
                </RequireAuth>
              }
            ></Route>
            <Route path={":user"} element={<PreviewPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          containerStyle={{
            top: 24,
            right: 20,
            zIndex: 9999999,
          }}
          toastOptions={{
            position: "top-right",
          }}
        />
      </CookiesProvider>
    </div>
  );
}

export default App;
